module.exports = __webpack_public_path__ + "static/media/IMG_8042.2564800b.jpg";